import React from 'react';
import { useTranslation } from 'react-i18next';

import type { UseFormRegisterReturn } from 'react-hook-form';
import { Button } from '../Button';
import { IconSearch } from '../Icon';
import Loader from '../Loader';
import { Icon, Input, Label, Search, Wrapper } from './wrapper';

type InputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

type Props = InputProps & {
  placeholder?: string;
  label: string;
  value?: string;
  id: string;
  disabled?: boolean;
  disabledButton?: boolean;
  autoFocus?: boolean;
  small?: boolean;
  sizeIconButton?: boolean;
  loading?: boolean;
  autoComplete?: string;
  onClickSearch?: () => void;
  register?: UseFormRegisterReturn;
};

const InputSearch = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      placeholder,
      label,
      value,
      id,
      disabled,
      disabledButton,
      autoFocus,
      small,
      sizeIconButton,
      loading,
      autoComplete,
      onChange,
      onKeyDown,
      onClickSearch,
      register,
    },
    ref,
  ) => {
    const { t } = useTranslation('common');

    return (
      <Wrapper ref={ref}>
        <Label htmlFor={id}>{label}</Label>
        <Search>
          <Icon htmlFor={id}>{loading ? <Loader inlineBlock /> : <IconSearch />}</Icon>
          <Input
            placeholder={placeholder}
            name="search"
            value={value}
            id={id}
            disabled={disabled}
            onChange={onChange}
            onKeyDown={onKeyDown}
            autoFocus={autoFocus}
            autoComplete={autoComplete}
            $small={small}
            $sizeIconButton={sizeIconButton}
            {...register}
          />
          {onClickSearch && (
            <Button
              $tone="base"
              $variant="square"
              disabled={disabled || disabledButton}
              onClick={onClickSearch}
              title={t('search', { ns: 'common' }) || ''}
            >
              {t('search', { ns: 'common' })}
            </Button>
          )}
        </Search>
      </Wrapper>
    );
  },
);

InputSearch.displayName = 'InputSearch';

export default InputSearch;
